<template>
<div id="logo" v-show="visible || inNav">
    <router-link :to="{name: 'home'}">Gulf of Maine Research Institute, LabVenture</router-link>
</div>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Logo',
    props: {
        inNav: false
    },
    computed: {
        ...mapGetters({
            'visible': 'global/logo_visible',
        })
    },
}
</script>


<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

$logo-size: 120px;

#logo {
    font-weight: $font-weight-bold;
    left: $s3;
    opacity: 1;
    position: fixed;
    top: $s3;
    z-index: 9990;

    a {
        background-image: url(/img/logo/lv-logo@2x.png);
        background-image:
            -webkit-image-set(
                url(/img/logo/lv-logo.png) 1x,
                url(/img/logo/lv-logo@2x.png) 2x,
            );
        background-image:
            image-set(
                url(/img/logo/lv-logo.png) 1x,
                url(/img/logo/lv-logo@2x.png) 2x,
            );

        background-size: $logo-size $logo-size;
        display: block;
        height: $logo-size;
        overflow: hidden;
        text-decoration: none;
        text-indent: -9000px;
        width: $logo-size;
    }

    &.hidden {
        opacity: 0;
        visibility: hidden;
    }
}


</style>
